import { render, staticRenderFns } from "./list-categories.vue?vue&type=template&id=51168a66&"
import script from "./list-categories.vue?vue&type=script&lang=js&"
export * from "./list-categories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports